module.exports = __webpack_public_path__ + "img/h-banner05_1.774ba940.png";